//eslint-disable @typescript-eslint/no-explicit-any
import React, { useEffect, useRef, useState } from "react";
import { SIDEBAR_GRAPH_WIDTH } from "../../../constants/constants";
import { DataNode } from "../../../interface/Trends";

import CollapseComponent from "./CollapseComponent";
import ColorAnalysisTable from "../TrendsSidebar/ColorAnalysisTable";
import {
  formatDataForColorAnalysisLevel1,
  showChart,
} from "../../../utils/trendSidebarGraphUtils/colorAnalysisUtils";

type ColorAnalysisProps = {
  width?: number;
  data1: DataNode | null;
  data2: DataNode | null;
  expandedView?: boolean;
};

const ColorAnalysisSnapShot: React.FC<ColorAnalysisProps> = ({
  width = SIDEBAR_GRAPH_WIDTH,
  data1,
  data2,
  expandedView = false,
}) => {
  const chartRef1 = useRef<HTMLDivElement>(null);
  const chartRef2 = useRef<HTMLDivElement>(null);

  const [l1Open, setL1Open] = useState(true);
  const [l2Open, setL2Open] = useState(true);

  const toggleL1Open = () => setL1Open(prev => !prev);
  const toggleL2Open = () => setL2Open(prev => !prev);

  useEffect(() => {
    if (chartRef1.current && data1) {
      formatDataForColorAnalysisLevel1(data1);
      showChart(
        data1,
        chartRef1.current,
        "LEVEL1",
        width,
        expandedView,
        undefined,
        true
      );
    }
    if (chartRef2.current && data2)
      showChart(
        data2,
        chartRef2.current,
        "LEVEL2",
        width,
        expandedView,
        undefined,
        true
      );
  }, [data1, data2]);

  return (
    <div className={`space-y-4 ${expandedView ? "bg-white" : "bg-dashboard"}`}>
      {!expandedView && data1 && (
        <CollapseComponent
          open={l1Open}
          toggle={toggleL1Open}
          text="L1 Analysis"
          snapshot={true}
        />
      )}
      <div
        ref={chartRef1}
        id="LEVEL1"
        className={` ${!l1Open ? "hidden" : "block"}`}
      ></div>
      {expandedView && <ColorAnalysisTable data1={data1} tableNo={1} />}
      {!expandedView && data2 && (
        <CollapseComponent
          open={l2Open}
          toggle={toggleL2Open}
          text="L2 Analysis"
          snapshot={true}
        />
      )}
      {data2 && (
        <div
          ref={chartRef2}
          id="LEVEL2"
          className={` ${!l2Open ? "hidden" : "block"}`}
        />
      )}
      {expandedView && <ColorAnalysisTable data2={data2} tableNo={2} />}
    </div>
  );
};

export default ColorAnalysisSnapShot;
